import { useTranslation } from "react-i18next";
import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import Section from "@/components/Section";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <>
      <SeoHead
        title={{
          en: "Contact Us | AI-labbet",
          sv: "Kontakta oss | AI-labbet",
        }}
        description={{
          en: "Get in touch with AI-labbet. Contact us to discuss your AI strategy, governance needs, or training programs.",
          sv: "Kontakta AI-labbet. Hör av dig för att diskutera er AI-strategi, styrningsbehov eller utbildningsprogram.",
        }}
        path="/contact"
      />
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <PageBreadcrumb currentPage="contact" />
        <main className="flex-grow">
          <Section
            title={<>{t("contactPage.titlePre")} <span>{t("contactPage.titleAccent")}</span></>}
            titleAs="h1"
            
            containerSize="narrow"
          >
            <div className="max-w-2xl mx-auto">
              <ContactForm />
            </div>
          </Section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
